import { useParams } from "react-router";
import type { EditableBlockKinds } from "schemas";

export function useBlockKindParam(): EditableBlockKinds {
  const { blockKind } = useParams() as { blockKind: EditableBlockKinds };

  return blockKind;
}
